// extracted by mini-css-extract-plugin
module.exports = {"title":"BlogIndexPage_title__3AxQk","articlesList":"BlogIndexPage_articlesList__235Wt","footer":"BlogIndexPage_footer__31nm3"};